/* Maison Septième: slide-out bag and predictive search (no dependencies) */
(() => {
  'use strict';
  const routes = (window.msTheme && window.msTheme.routes) || {};
  const DRAWER_ID = 'MsCartDrawer';
  const SECTION = 'ms-cart-drawer';

  /* ---------- Cart ---------- */
  const drawer = () => document.getElementById(DRAWER_ID);
  const onCartPage = () => Boolean(document.querySelector('[data-cart-page]'));

  const renderDrawer = (sections) => {
    const d = drawer();
    if (!d || !sections || !sections[SECTION]) return;
    const doc = new DOMParser().parseFromString(sections[SECTION], 'text/html');
    const next = doc.querySelector('[data-cart-drawer-inner]');
    const current = d.querySelector('[data-cart-drawer-inner]');
    if (next && current) current.replaceWith(next);
  };

  const updateCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
    document.querySelectorAll('[data-cart-open]').forEach((el) => el.setAttribute('aria-label', `Cart, ${count} items`));
  };

  const refreshCount = async () => {
    try {
      const res = await fetch(`${routes.cart || '/cart'}.js`, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      updateCount(cart.item_count);
    } catch (e) { /* ignore */ }
  };

  const openDrawer = (trigger) => {
    if (window.msOpenDrawer) window.msOpenDrawer(DRAWER_ID, trigger);
  };

  const showError = (message) => {
    const el = document.querySelector('.is-open [data-cart-error], [data-cart-page] [data-cart-error]');
    if (!el) { window.alert(message); return; }
    el.textContent = message;
    el.hidden = false;
  };

  /** Add to cart with FormData (supports photo uploads). Returns true on success. */
  const addToCart = async (formData, trigger) => {
    formData.append('sections', SECTION);
    formData.append('sections_url', window.location.pathname);
    const res = await fetch(`${routes.cartAdd || '/cart/add'}.js`, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });
    const json = await res.json();
    if (!res.ok || json.status) throw new Error(json.description || json.message || 'Something went wrong. Please try again.');
    renderDrawer(json.sections);
    await refreshCount();
    openDrawer(trigger);
    return true;
  };

  const changeLine = async (line, quantity) => {
    const res = await fetch(`${routes.cartChange || '/cart/change'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: [SECTION], sections_url: window.location.pathname }),
    });
    const json = await res.json();
    if (!res.ok || json.status) throw new Error(json.description || json.message || 'Could not update your bag.');
    if (onCartPage()) { window.location.reload(); return; }
    renderDrawer(json.sections);
    updateCount(json.item_count);
  };

  /** Add extra lines (for example a paid add-on) and refresh the open drawer. */
  const addItems = async (items) => {
    const res = await fetch(`${routes.cartAdd || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: [SECTION], sections_url: window.location.pathname }),
    });
    const json = await res.json();
    if (!res.ok || json.status) throw new Error(json.description || json.message || 'Your add-on could not be added. Please try again.');
    renderDrawer(json.sections);
    await refreshCount();
    return true;
  };

  window.msCart = { addToCart, addItems, openDrawer, refreshCount };

  document.addEventListener('click', async (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && drawer() && !onCartPage()) {
      e.preventDefault();
      openDrawer(opener);
      return;
    }

    const qty = e.target.closest('[data-qty-change]');
    const remove = e.target.closest('[data-line-remove]');
    if (qty || remove) {
      const item = e.target.closest('[data-line]');
      if (!item) return;
      const current = parseInt(item.dataset.quantity, 10) || 1;
      const next = remove ? 0 : Math.max(0, current + parseInt(qty.dataset.qtyChange, 10));
      item.classList.add('is-updating');
      try { await changeLine(parseInt(item.dataset.line, 10), next); } catch (err) { item.classList.remove('is-updating'); showError(err.message); }
      return;
    }

    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      const fd = new FormData();
      fd.append('id', quick.dataset.quickAdd);
      fd.append('quantity', '1');
      quick.disabled = true;
      try { await addToCart(fd, quick); } catch (err) { showError(err.message); quick.disabled = false; }
    }
  });

  /* ---------- Predictive search ---------- */
  const input = document.querySelector('[data-predictive-input]');
  const results = document.querySelector('[data-predictive-results]');
  if (input && results && window.msTheme && window.msTheme.predictive !== false && routes.predictiveSearch) {
    let timer;
    let controller;
    const run = async () => {
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      if (controller) controller.abort();
      controller = new AbortController();
      const params = new URLSearchParams({
        q,
        section_id: 'ms-predictive-search',
        'resources[type]': 'product,collection,page,article',
        'resources[limit]': '4',
        'resources[options][unavailable_products]': 'last',
      });
      try {
        const res = await fetch(`${routes.predictiveSearch}?${params}`, { signal: controller.signal });
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const block = doc.querySelector('#MsPredictiveResults');
        results.innerHTML = block ? block.outerHTML : '';
      } catch (err) { /* aborted or offline */ }
    };
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 220); });
  }
})();
